import { Button, Card, CardBody, CardHeader, CardHeading, Empty, FCC, Trigger } from "@dgs/core";
import React, { useId } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { SubscribeToNewsletterDrawer } from "../../contacts/view/SubscribeToNewsletterDrawer";
import { IContactUpdateResource } from "../../shared/types";
import { ListItemTrailing } from "../../shared/ui/list/listComponents";
import { ListItemTitle } from "../../shared/ui/list/ListItemTitle";

const MinimalList = styled.div`
	display: grid;
	grid-template-columns: 1fr max-content;
	grid-auto-rows: 1fr;
	gap: ${({ theme }) => theme.spacing(2)};
`;

const SubscribeContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: ${({ theme }) => theme.spacing(2)};
	gap: ${({ theme }) => theme.spacing(4)};
`;

interface Props {
	contact: IContactUpdateResource;
	showSubscribeButton?: boolean;
}

export const NewsletterListCard: FCC<Props> = ({ contact, showSubscribeButton = true }) => {
	const { t } = useTranslation();
	const labelId = useId();
	return (
		<Card aria-labelledby={labelId}>
			<CardHeader>
				<CardHeading id={labelId}>{t("Newsletters")}</CardHeading>
			</CardHeader>
			<CardBody>
				<MinimalList>
					{contact.newsletters.map((x) => (
						<React.Fragment key={x.id}>
							<ListItemTitle>{x.subdomain}</ListItemTitle>
							<ListItemTrailing>{x.status && t(x.status)}</ListItemTrailing>
						</React.Fragment>
					))}
					{!contact.newsletters.length && (
						<SubscribeContainer>
							<Empty>{t("Not subscribed to a newsletter.")}</Empty>
							{showSubscribeButton && (
								<Trigger render={(renderProps) => <SubscribeToNewsletterDrawer contact={contact} {...renderProps} />}>
									{(triggerProps) => <Button {...triggerProps}>{t("Subscribe to a newsletter")}</Button>}
								</Trigger>
							)}
						</SubscribeContainer>
					)}
				</MinimalList>
			</CardBody>
		</Card>
	);
};
